import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let ServerContext: string;
    let ServerDataContext: string;
    if (
      request.headers.get('LgContext') === 'ECOMM' &&
      !request.headers.get('ECommServer')
    ) {
      ServerContext = 'ECOMM2';
      ServerDataContext = 'ECOMM2';
    } else if (request.headers.get('LgContext') === 'BOOKING') {
      ServerContext = 'BOOKING2';
      ServerDataContext = 'BOOKING2';
    } else {
      ServerContext = sessionStorage.getItem('PortalIdentifier')
        ? sessionStorage.getItem('PortalIdentifier')
        : 'INSTA-IN';
      ServerDataContext = sessionStorage.getItem('PortalDS')
        ? sessionStorage.getItem('PortalDS')
        : 'INSTA-IN';
    }

    //if (request.url.includes(location.origin) && !request.headers.get("ECommServer")) {
    if (!request.headers.get('PortalContext')) {
      request = request.clone({
        setHeaders: {
          AuthContext: 'MANIKAPP',
          AuthEntityID: '16395',
          AuthEntityHandle: 'ANJAANONE',
          PortalContext: ServerContext,
          PortalDS: ServerDataContext,
        },
      });
    } else {
      request = request.clone({
        setHeaders: {
          AuthContext: 'MANIKAPP',
          AuthEntityID: '16395',
          AuthEntityHandle: 'ANJAANONE',
        },
      });
    }
    //}

    return next.handle(request);
  }
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor() {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          let PortalIdentifier = sessionStorage.getItem('PortalIdentifier');
          sessionStorage.clear();
          sessionStorage.setItem('PortalIdentifier', PortalIdentifier);
          localStorage.clear();
          location.reload();
        }

        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
}
